module.exports = __webpack_public_path__ + "img/NE.fe232d8a.svg";